
  <div class="product__wrapper mb-60" *ngIf="product">
      <div class="product__thumb product__thumb p-2 d-flex align-items-center justify-content-center">
          <a [routerLink]="['/shop/product', product.id]" class="w-img">
              <img [src]="(product.product_image)?product.path+product.product_image:'assets/img/shop/product/product_1.png'" alt="product-img">
              <!-- <img class="product__thumb-2" [src]="(product.product_image)?product.product_image:'assets/img/shop/product/product_1.png'" alt="product-img"> -->
          </a>
          <div class="product__action transition-3">
              <a (click)="addToWishlist(product)" class="cursor-pointer" [class.active]="isItemInWishlist(product)" data-bs-toggle="tooltip" data-placement="top" title="Add to Wishlist">
                  <i class="fal fa-heart"></i>
              </a>
              <a (click)="addToCompare(product)" class="cursor-pointer" [class.active]="isItemInCompare(product)" data-toggle="tooltip" data-placement="top" title="Compare">
                  <i class="fal fa-sliders-h"></i>
              </a>
              <!-- Button trigger modal -->
              <!-- <a class="cursor-pointer" data-bs-toggle="modal" [attr.data-bs-target]="'#' + utilsService.modalId" (click)="utilsService.handleOpenModal('product-modal-' + product.id, product)">
                  <i class="fal fa-search"></i>
              </a> -->
          </div>
          <div *ngIf="product.discount || product.new" class="product__sale">
            <span *ngIf="product.new || product.discount" class="new">new</span>
            <span *ngIf="product.discount" class="percent">-{{ product.discount }}%</span>
          </div>
      </div>
      <div class="product__content p-relative">
          <div class="product__content-inner">
              <h4><a [routerLink]="['/shop/product', product.id]" [innerHTML]="product.title"></a></h4>
              <div class="product__price transition-3">
                  <span>₹{{ (product.sale_price)?product.sale_price.toFixed(2):product.regular_price.toFixed(2) }}</span>
                  <span *ngIf="product.sale_price" class="old-price">₹{{product.regular_price.toFixed(2)}}</span>
              </div>
          </div>
          <div class="add-cart p-absolute transition-3">
              <a *ngIf="!isItemInCart(product)" (click)="addToCart(product)" class="cursor-pointer">
                + Add to Cart
              </a>
              <a *ngIf="isItemInCart(product)" routerLink="/shop/cart" class="cursor-pointer">
                View Cart
              </a>
          </div>
      </div>
  </div>

